document.addEventListener('DOMContentLoaded', () => {
  const PUBLIC_TOKEN = '2a1feb6370795a3e9650560d236dfbd6';
  const API_VERSION = '2026-07';

  const shippingBlock =
    document.getElementById('NeedShippingRate');

  if (!shippingBlock) {
    console.error('NeedShippingRate block not found');
    return;
  }

  const countryCode =
    shippingBlock.dataset.countryCode;

  const countryName =
    shippingBlock.dataset.countryName;

  const DEFAULT_PROVINCE_CODES = {
    IT: 'RM', // Italy — Rome
    IE: 'D',  // Ireland — Dublin
    PT: '11', // Portugal — Lisbon
    RO: 'B',  // Romania — Bucharest
    ES: 'M',  // Spain — Madrid
    US: 'NY'  // United States — New York
  };

  let requestNumber = 0;
  let debounceTimer = null;
  let animationTimer = null;

  const mutation = `
    mutation ShippingRate($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          deliveryGroups(first: 10) {
            nodes {
              deliveryOptions {
                title
                estimatedCost {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  function getVariantInput() {
    return document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );
  }

  function getQuantityInput() {
    return (
      document.querySelector(
        '.product-form__quantity input[name="quantity"]'
      ) ||
      document.querySelector(
        'input[name="quantity"]'
      )
    );
  }

  function getQuantity() {
    const quantityInput = getQuantityInput();

    const quantity = Number.parseInt(
      quantityInput?.value || '1',
      10
    );

    return Number.isFinite(quantity) && quantity > 0
      ? quantity
      : 1;
  }

  async function calculateShipping() {


    const addToCartButton = document.querySelector(
      'form[action*="/cart/add"] button[name="add"]'
    );

    const isSoldOut =
      !addToCartButton ||
      addToCartButton.disabled ||
      addToCartButton.getAttribute('aria-disabled') === 'true';

    if (isSoldOut) {
      shippingBlock.hidden = true;
      shippingBlock.innerHTML = '';
      return;
    }



    const variantInput = getVariantInput();

    if (!variantInput?.value) {
      console.error('Variant ID not found');
      shippingBlock.hidden = true;
      return;
    }

    const variantId = variantInput.value;
    const quantity = getQuantity();

    const provinceCode =
      DEFAULT_PROVINCE_CODES[countryCode] || null;

    const deliveryAddress = {
      countryCode
    };

    if (provinceCode) {
      deliveryAddress.provinceCode = provinceCode;
    }

    const variables = {
      input: {
        lines: [
          {
            merchandiseId:
              `gid://shopify/ProductVariant/${variantId}`,
            quantity
          }
        ],
        buyerIdentity: {
          countryCode
        },
        delivery: {
          addresses: [
            {
              address: {
                deliveryAddress
              },
              selected: true,
              oneTimeUse: true,
              validationStrategy:
                'COUNTRY_CODE_ONLY'
            }
          ]
        }
      }
    };

    const currentRequest = ++requestNumber;

    try {
      const response = await fetch(
        `/api/${API_VERSION}/graphql.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token':
              PUBLIC_TOKEN
          },
          body: JSON.stringify({
            query: mutation,
            variables
          })
        }
      );

      const result = await response.json();

      /*
       * Если пользователь быстро изменил количество,
       * игнорируем ответ от старого запроса.
       */
      if (currentRequest !== requestNumber) {
        return;
      }

      if (!response.ok) {
        console.error(
          'Shipping API HTTP error:',
          response.status,
          result
        );

        shippingBlock.hidden = true;
        return;
      }

      if (result.errors?.length) {
        console.error(
          'Shipping API GraphQL errors:',
          result.errors
        );

        shippingBlock.hidden = true;
        return;
      }

      const userErrors =
        result?.data?.cartCreate?.userErrors || [];

      if (userErrors.length) {
        console.error(
          'Shipping API user errors:',
          userErrors
        );

        shippingBlock.hidden = true;
        return;
      }

      const groups =
        result?.data?.cartCreate?.cart
          ?.deliveryGroups?.nodes || [];

      const options = groups.flatMap(
        group => group.deliveryOptions || []
      );

if (!options.length) {
  renderShippingResult({
    label: 'Quote',
    value: 'Required',
    animate: true
  });

  return;
}

      const cheapest = options.reduce(
        (lowest, current) => {
          return Number(
            current.estimatedCost.amount
          ) < Number(
            lowest.estimatedCost.amount
          )
            ? current
            : lowest;
        }
      );

      const price = new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        {
          style: 'currency',
          currency:
            cheapest.estimatedCost.currencyCode,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      ).format(
        Number(cheapest.estimatedCost.amount)
      );


renderShippingResult({
  label: 'From',
  value: price,
  animate: true
});




    } catch (error) {
      console.error(
        'Shipping rate failed:',
        error
      );

      shippingBlock.hidden = true;
    }
  }

  function scheduleCalculation() {
    window.clearTimeout(debounceTimer);

    debounceTimer = window.setTimeout(
      calculateShipping,
      300
    );
  }

  /*
   * Пересчёт после изменения количества
   * или выбранного варианта.
   */
  document.addEventListener('change', event => {
    if (
      event.target.matches(
        'input[name="quantity"], input[name="id"], select[name="id"]'
      )
    ) {
      scheduleCalculation();
    }
  });

  document.addEventListener('input', event => {
    if (
      event.target.matches(
        'input[name="quantity"]'
      )
    ) {
      scheduleCalculation();
    }
  });

  /*
   * В Dawn кнопки +/− могут обновлять input
   * после события click, поэтому ждём 100 мс.
   */
  document.addEventListener('click', event => {
    if (
      event.target.closest(
        'quantity-input .quantity__button'
      )
    ) {
      window.setTimeout(
        scheduleCalculation,
        100
      );
    }
  });





function renderShippingResult({
  label,
  value,
  animate = false
}) {
  let labelElement =
    shippingBlock.querySelector(
      '.need-shipping-rate__right .need-shipping-rate__label'
    );

  let priceElement =
    shippingBlock.querySelector(
      '.need-shipping-rate__price'
    );

  /*
   * Создаём структуру только один раз.
   */
  if (!labelElement || !priceElement) {
    shippingBlock.innerHTML = `
      <div class="need-shipping-rate__left">
        <div class="need-shipping-rate__destination">

<div class="need-shipping-rate__label-row">
  <span class="need-shipping-rate__label">
    Shipping to
  </span>

 <span
  class="need-shipping-rate__info"
  aria-label="Shipping information"
>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="14"
  height="14"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="1.8"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <circle cx="12" cy="12" r="9"></circle>
  <path d="M12 10v5"></path>
  <path d="M12 7.2h.01"></path>
</svg>

</span>

<div
  class="need-shipping-rate__tooltip"
  role="tooltip"
>
  Some additional items may be shipped at
  <span class="need-tooltip-highlight">
    no extra delivery cost
  </span>,
  depending on the total parcel size and weight.
</div>


</div>

          <strong class="need-shipping-rate__country"></strong>
        </div>
      </div>

      <div class="need-shipping-rate__right">
        <span class="need-shipping-rate__label"></span>

        <strong
          class="need-shipping-rate__price"
          aria-live="polite"
        ></strong>
      </div>
    `;

    shippingBlock.querySelector(
      '.need-shipping-rate__country'
    ).textContent = countryName;

    labelElement =
      shippingBlock.querySelector(
        '.need-shipping-rate__right .need-shipping-rate__label'
      );

    priceElement =
      shippingBlock.querySelector(
        '.need-shipping-rate__price'
      );
  }

  const previousValue =
    priceElement.textContent.trim();

  labelElement.textContent = label;

  /*
   * Если значение не изменилось,
   * ничего дополнительно не делаем.
   */
  if (previousValue === value) {
    shippingBlock.hidden = false;
    return;
  }

  priceElement.textContent = value;

 if (animate && previousValue) {
  window.clearTimeout(animationTimer);

  priceElement.classList.remove('is-changed');

  /*
   * Перезапускаем CSS-анимацию.
   */
  void priceElement.offsetWidth;

  priceElement.classList.add('is-changed');

  animationTimer = window.setTimeout(() => {
    priceElement.classList.remove('is-changed');
  }, 600);
}

  shippingBlock.hidden = false;
}





  calculateShipping();
});